<template>
  <div>
    <component
      :is="
        components[resource.template as keyof typeof components] ||
        components.default
      "
      :key="route.fullPath"
      :content="content"
    />
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent, DefineComponent } from 'vue'
import { useRoute } from 'vue-router'

import { useResourceStore } from '@/stores/resource'

defineProps({
  content: {
    type: Object,
    required: true,
  },
})

const route = useRoute()
const resource = useResourceStore()

const components = {
  default: defineAsyncComponent(() => import('@/views/pages/Default.vue')),
  subservice: defineAsyncComponent(() => import('@/views/SubService.vue')),
  contact: defineAsyncComponent(
    () => import('@/views/pages/ContactLayout.vue')
  ),
  notfound: defineAsyncComponent(() => import('@/views/404.vue')),
  'game-404': defineAsyncComponent(() => import('@/views/404.vue')),
  // subservice: defineAsyncComponent(() => import('@/views/SubService.vue')),
}
</script>
